import { useDispatch, useSelector } from 'react-redux';
import { dynamicDataSelectors } from '@/Redux/DynamicData';
import {
  orderLabelPrintActions,
  orderLabelPrintAsyncActions,
  orderLabelPrintModalSelectors,
} from '@/ModalWindows/OrderLabelPrintModal/services';
import { useCountryOptions } from '@/Enums/CountryTypeHooks';
import { useEffect } from 'react';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { shippingLabelModalSelectors } from '@/ModalWindows/ShippingLabelModal/services';

export function useOrderLabelPrintOptions() {
  const dispatch: AppDispatch = useDispatch();

  const countryOptions = useCountryOptions();
  const selectedOrderIds = useSelector(shippingLabelModalSelectors.filteredOrderIdsByWarehouse);
  const isAllSelectedCreated = useSelector(orderLabelPrintModalSelectors.isAllSelectedCreated);
  const logisticTypesOptions = useSelector(dynamicDataSelectors.genLogisticTypesData.logisticTypesOptions);

  useEffect(() => {
    dispatch(orderLabelPrintActions.setCountryOptions(countryOptions));
    dispatch(orderLabelPrintActions.setLogisticTypes(logisticTypesOptions));
    dispatch(orderLabelPrintAsyncActions.getOrderLabelInfoRequest({ orderIds: selectedOrderIds }));

    return () => {
      dispatch(orderLabelPrintActions.resetState());
    };
  }, []);

  return {
    selectedOrderIds,
    isAllSelectedCreated,
  };
}
